import { isNil, omitBy } from 'lodash-es';
import type { CoreTypes } from '../../core';
import type { Activity } from '../types/activities';

export default (
  activities: Activity[],
  options?:   { interval?: { start: string, end: string } }
):  CoreTypes.MixedWithoutInternalId.Course[] => {
  if (!Array.isArray(activities))
    throw new Error('(SS12000::From::Activities) Activities input is not of array type', { cause: 'invalid_input' });

  const parentActivities = new Set(activities.map(x => x.parentActivity?.id).filter(Boolean));

  return activities
    .map((activity): CoreTypes.MixedWithoutInternalId.Course | undefined => {
      // Skip activities that are above courses
      if (parentActivities.has(activity.id)) return;

      const groupIndexSet = [...new Set<number | undefined>([undefined, ...(activity.rooms?.map(({ index }) => index) ?? [])])];

      const doc = {
        ids:       activity.id,
        startDate: activity.startDate,
        ...omitBy({
          displayName: activity.displayName,
          comment:     activity.comment,
          subject:     activity.subject,
          endDate:     activity.endDate,
          syllabus:    activity._embedded?.syllabus,
        }, isNil),
        ...activity.minutesPlanned && { plannedDuration: `${ Math.ceil(activity.minutesPlanned / 60) } hrs` },
        type:     activity.activityType,
        groups:   activity.groups?.map(({ id }) => ({ to: id })),
        teachers: activity.teachers?.map(({ duty: { id } }) => ({ to: id })),
        // not in the standard
        ...activity.rooms && {
          locations: activity.rooms?.map(({ room, index }) => ({ locations: [room.id!] as [string], groupIndex: groupIndexSet.indexOf(index) })),
        },
        ...activity._embedded?.syllabus && {
          subject: activity._embedded.syllabus.subjectCode,
        }
      };
      return doc;
    })
    .filter(x => x != null);
};